import { ILocalizedStringDto } from '@data-access/bulk-operations-api';

import { LanguagesEnum } from '../enums/languages.enum';
import { getLocalePreference } from './locale.helpers';

export function getTranslationFromLocalizedString(value: ILocalizedStringDto): string {
  return getLocalePreference() === LanguagesEnum.No ? value?.norwegian : value?.english;
}
